import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import ProfileSectionCard from '@/components/setting/users/ProfileSectionCard';
import PopupSetName from '@/components/setting/users/PopupSetName';
import PopupSetLang from '@/components/setting/users/PopupSetLang';
import PopupSetTimeZone from '@/components/setting/users/PopupSetTimeZone';
import PopupSetTempUnit from '@/components/setting/users/PopupSetTempUnit';

interface ProfileInformationProps {
  name: string;
  email: string;
  language: string;
  tz: string;
  tempUnit: 'CELSIUS' | 'FAHRENHEIT';
}

export default function ProfileInformation({ name, email, language, tz, tempUnit }: ProfileInformationProps) {
  const { t } = useTranslation();

  return (
    <>
      <Typography variant="h5" fontWeight={'bold'}>
        {t('Settings.label.profileInformation')}
      </Typography>
      <ProfileSectionCard title={t('Common.label.name')} value={name}>
        <PopupSetName name={name} />
      </ProfileSectionCard>
      <ProfileSectionCard title={t('Settings.label.email')} value={email} />
      <ProfileSectionCard title={t('Settings.label.language')} value={language === 'ko-KR' ? '한국어' : 'English'}>
        <PopupSetLang lan={language} />
      </ProfileSectionCard>
      <ProfileSectionCard title={t('Settings.label.timezone')} value={tz}>
        <PopupSetTimeZone timeZone={tz} />
      </ProfileSectionCard>
      <ProfileSectionCard title={t('Devices.label.temperatureUnit')} value={tempUnit === 'CELSIUS' ? '℃' : '℉'}>
        <PopupSetTempUnit currentUnit={tempUnit} />
      </ProfileSectionCard>
    </>
  );
}
